module.exports = __webpack_public_path__ + "static/media/menu-arrow-down.59699df8.svg";